class YoutubeVideo {
  constructor($main) {
    this.initDomElements($main);
    this.domElements.previewImage.on("click", () => {
      this.showVideo();
    });
    this.domElements.btn.on("click", () => {
      this.showVideo();
    });
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.previewImage = this.domElements.main.find(
      ".youtube-video__preview-image"
    );
    this.domElements.btn = this.domElements.main.find(".youtube-video__advice");
    this.domElements.iframe = this.domElements.main.find("iframe");
    return true;
  }

  showVideo() {
    this.domElements.previewImage.fadeOut();
    this.domElements.btn.fadeOut();
    this.domElements.iframe.attr("src", this.domElements.iframe.data("src"));
  }
}

export default YoutubeVideo;
